module.exports = __webpack_public_path__ + "static/media/blog1_2.5f8961f3.webp";